import React from "react";

interface InfoColumnProps {
    icon: string;
    title: string;
    description: string;
}

const InfoColumn: React.FC<InfoColumnProps> = ({
    icon,
    title,
    description,
}) => {
    return (
        <article className="flex flex-col items-center text-center max-w-[414px]">
            <div className="mb-6">
                <i className={`ti ${icon} text-3xl text-black`} />
            </div>
            <h2 className="mb-0.5 text-3xl font-bold leading-10 text-black max-md:text-2xl max-sm:text-2xl">
                {title}
            </h2>
            <p className="text-sm leading-5 text-black max-md:text-sm">
                {description}
            </p>
        </article>
    );
};

export default InfoColumn;
